var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c(
        "div",
        { staticClass: "hp-calendar" },
        [
          _c(
            "z-caption",
            {
              staticClass: "u-bottom-margin--xl",
              attrs: {
                size: "xl",
                href: "/" + _vm.$root.lang + "/investors/calendar/",
                uppercase: "",
              },
            },
            [_c("span", { domProps: { innerHTML: _vm._s(_vm.text.title) } })]
          ),
          _vm._v(" "),
          _c("z-card", {
            staticClass: "hp-calendar__card",
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function () {
                    return [
                      _vm.upcomingEvents.length
                        ? _c(
                            "slider",
                            _vm._l(_vm.upcomingEvents, function (item, index) {
                              return _c("slide", { key: index }, [
                                _c(
                                  "div",
                                  { staticClass: "hp-calendar-slide" },
                                  [
                                    _c("date-block", {
                                      staticClass: "hp-calendar-slide__date",
                                      attrs: {
                                        size: "xl",
                                        date: item.dateFrom.timestamp,
                                        "date-end":
                                          item.dateFrom.timestamp ===
                                          item.dateTo.timestamp
                                            ? ""
                                            : item.dateTo.timestamp,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "hp-calendar-slide__info",
                                      },
                                      [
                                        _c(
                                          "z-caption",
                                          {
                                            attrs: { size: "m", weight: "500" },
                                          },
                                          [
                                            _c(
                                              "z-link",
                                              {
                                                attrs: {
                                                  theme: "black",
                                                  href:
                                                    "/" +
                                                    _vm.$root.lang +
                                                    "/investors/calendar/",
                                                },
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      item.name
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            1
                          )
                        : [
                            _c(
                              "z-caption",
                              {
                                staticClass: "black-text",
                                attrs: { size: "xl", tag: "h1" },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(_vm.text.noEvents.title),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.text.noEvents.description
                                ),
                              },
                            }),
                          ],
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2817279974
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }